<template>
	<div>
		<v-data-table :items="itens" dense :headers="getColunas()" hide-default-footer disable-pagination>
			<template #item.descricao="{ item }">
				<texto-tooltip :texto="item.descricao" :tamanho-maximo="40"></texto-tooltip>
			</template>
			<template #item.acoes="{ item }">
				<v-btn-toggle
					v-ripple="false"
					variant="text"
					borderless
					primary
					v-model="item.selecionado"
					@change="removerItem(item)"
				>
					<v-tooltip top color="black">
						<template #activator="{ on }">
							<v-btn
								icon
								fab
								v-on="on"
								v-ripple="false"
								block
								:value="false"
								primary
								v-if="isNaoAdicionado(item)"
							>
								<v-icon color="primary">mdi-plus-circle</v-icon>
							</v-btn>
							<v-btn icon fab v-on="on" v-ripple="false" block :value="true" primary v-else>
								<v-icon color="error">mdi-minus-circle</v-icon>
							</v-btn>
						</template>
						<span>{{ getTextoAdicionarRemover(item) }}</span>
					</v-tooltip>
				</v-btn-toggle>
			</template>
		</v-data-table>
		<paginacao-tabela
			:total-paginas="totalPages"
			:total-itens="totalElements"
			:page.sync="busca.paginacao.page"
			:rows-per-page.sync="busca.paginacao.rowsPerPage"
			:show-rows-per-page="false"
		></paginacao-tabela>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import { mapGetters } from 'vuex'

export default {
	name: 'listagem-interna-selecionados',
	props: {
		itemSelecionado: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			itens: [],
			totalPages: 0,
			totalElements: 0,
			busca: {
				filtro: {
					idProcesso: this.itemSelecionado.idProcesso,
					idFornecedor: this.itemSelecionado.idFornecedor,
					idLotes: this.itemSelecionado.editais.map((edital) => edital.lotes),
					itensNaoAdicionados: [],
					numeroEditais: this.itemSelecionado.editais.map((edital) => edital.numeroEdital),
				},
				paginacao: PaginacaoListagem(['id']),
			},
			isIntegracaoWeblicAtivo: this.$store.state.parametrosSistema.isIntegracaoWeblicAtivo,
		}
	},
	computed: {
		...mapGetters({
			isNaoAdicionado: getterTypes.ITEM_ATA.IS_NAO_ADICIONADO,
		}),
		deveExibirCampoNumeroIntegracaoAtiva() {
			return this.isIntegracaoWeblicAtivo
		},
	},
	watch: {
		busca: {
			handler(novoValor) {
				this.busca.paginacao = novoValor.paginacao
				this.carregarListagem()
			},
			deep: true,
		},
	},
	async mounted() {
		await this.carregarListagem()
	},
	methods: {
		getTextoAdicionarRemover(item) {
			if (!item.selecionado) return 'Remover da seleção'
			return 'Adicionar à seleção'
		},
		removerItem(item) {
			this.$store.commit(mutationTypes.ITEM_ATA.SET_FILTRO_ITENS_IGNORADOS, {
				item: this.itemSelecionado,
				itemIgnorado: item,
			})
		},
		async carregarListagem() {
			const { itens, totalPages, totalElements } = await this.$store.dispatch(
				actionTypes.ITEM_PROCESSO.BUSCAR_ITENS_PROCESSOS_POR_FORNECEDOR,
				this.busca,
			)
			this.itens = itens
			this.totalPages = totalPages
			this.totalElements = totalElements
		},
		getColunas() {
			const primeiraColunaTitulo = this.deveExibirCampoNumeroIntegracaoAtiva ? 'Nº Edital' : 'Nº Processo'
			return [
				new TabelaColunaUtils(primeiraColunaTitulo, 'processo.numero', '20%'),
				new TabelaColunaUtils('Grupo', 'loteEntity.tituloFormatado', '10%'),
				new TabelaColunaUtils('Descrição', 'descricao', '65%'),
				new TabelaColunaUtils('', 'acoes', '5%'),
			]
		},
	},
}
</script>
<style lang="stylus" scoped>
.v-btn:before {
	opacity: 0 !important;
}

.v-ripple__container {
	opacity: 0 !important;
}

.v-btn-toggle:hover {
	background-color: transparent !important;
}

.v-btn-toggle {
	background-color: transparent !important;
}
</style>
